import { useGetByID } from './useGetByID'

export const engagements = {
  getByID: useGetByID,
}
